<template>
  <div class="videobox">
    <video
      :id="'videoPlayer' + id"
      style="width: 100%; height: 100%; object-fit: fill"
      preload="none"
      autoplay
      muted
    ></video>
    <div class="openVideo" @click="openVideo" v-loading="loading">
      <i class="el-icon-full-screen"></i>
    </div>
  </div>
</template>
<script>
  import flvjs from "flv.js";
  export default {
    data() {
      return {
        loading: false,
        videoTypeFlag: 0, // 视频播放类型，1：萤石云用flv，2：内网:用websocket

        livestream: null,
        verbose: true,
        streamingStarted: false,
        ms: null,
        queue: [],
        videoWs: null,
        sourceBuffer: null,
        decoded_arr: null,
        mimeCodec: null,
      };
    },
    props: {
      videoUrl: {
        type: String,
      },
      height: {
        type: Number,
        // default:600
      },
      displayForm: {
        type: Boolean,
      },
      poster: {
        type: String,
      },
      id: {
        type: Number,
      },
    },
    components: {},
    watch: {
      videoUrl: {
        handler(newOptionValue) {
          this.videoUrl = newOptionValue;

          this.ms = new MediaSource();
          this.ms.addEventListener("sourceopen", this.opened, false);
          this.livestream.src = window.URL.createObjectURL(this.ms);
          try{
            this.videoWs.close();
          }catch (e) {

          }
          if (this.flvPlayer) {
            this.flvPlayer.destroy();
          }
          this.initPlayer()
        },
        deep: true,
      },
    },
    methods: {
      openVideo() {
        this.$emit("openVideo", this.id);
      },
      initPlayer() {
        console.log(this.videoUrl)
        let vPlayer = document.getElementById("videoPlayer" + this.id);
        var httpUrl = this.videoUrl.indexOf("http");
        var wsUrl = this.videoUrl.indexOf("ws");
        if (httpUrl == 0) {
          this.videoTypeFlag = 1;
          console.log("字符串是以http开头的！");
          if (flvjs.isSupported()) {
            this.flvPlayer = flvjs.createPlayer({
              type: "flv",
              url: this.videoUrl,
            });
          } else {
            this.$message.error("不支持的格式");
            return;
          }
          this.flvPlayer.attachMediaElement(vPlayer);
          this.flvPlayer.load();
          this.flvPlayer.play();
        }
        if (wsUrl == 0) {
          this.videoTypeFlag = 2;
          console.log("字符串是以ws开头的！");
          this.opened(this.videoUrl); //("ws://127.0.0.1:8888/ws/live?suuid=video_01");
        }
      },
      pushPacket(arr) {
        var view = new Uint8Array(arr);
        if (this.verbose) {
          // console.log("got", arr.byteLength, "bytes.  Values=", view[0], view[1], view[2], view[3], view[4]);
        }
        this.data = arr;
        if (!this.streamingStarted) {
          try {
            this.sourceBuffer.appendBuffer(this.data);
          } catch (e) {}
          this.streamingStarted = true;
          return;
        }
        this.queue.push(this.data);
        if (this.verbose) {
          // console.log("queue push:", this.queue.length);
        }
        if (!this.sourceBuffer.updating) {
          this.loadPacket();
        }
      },

      loadPacket() {
        if (!this.sourceBuffer.updating) {
          if (this.queue.length > 0) {
            var inp = this.queue.shift();
            if (this.verbose) {
              // console.log("queue PULL:", this.queue.length);
            }
            var view = new Uint8Array(inp);
            if (this.verbose) {
              // console.log(
              //   "writing buffer with",
              //   view[0],
              //   view[1],
              //   view[2],
              //   view[3],
              //   view[4]
              // );
            }
            this.sourceBuffer.appendBuffer(inp);
          } else {
            this.streamingStarted = false;
          }
        }
      },
      opened(inputVal) {
        try {
          var httpUrl = inputVal.indexOf("http");
          var wsUrl = inputVal.indexOf("ws");
          if (httpUrl != 0 && wsUrl != 0) {
            return;
          }
        }catch (e) {
          return;
        }
        this.videoWs = new WebSocket(inputVal);
        this.videoWs.binaryType = "arraybuffer";
        this.videoWs.onopen = function () {
          console.log("Connect");
        };
        let slf = this;
        this.videoWs.onmessage = function (event) {
          var data = new Uint8Array(event.data);
          if (data[0] == 9) {
            slf.decoded_arr = data.slice(1);
            if (window.TextDecoder) {
              slf.mimeCodec = new TextDecoder("utf-8").decode(slf.decoded_arr);
            } else {
              slf.mimeCodec = this.Utf8ArrayToStr(slf.decoded_arr);
            }
            if (this.verbose) {
              // console.log("first packet with codec data: " + slf.mimeCodec);
            }
            slf.sourceBuffer = slf.ms.addSourceBuffer(
              'video/mp4; codecs="' + slf.mimeCodec + '"'
            );
            console.log(slf.sourceBuffer);
            slf.sourceBuffer.mode = "segments";
            slf.sourceBuffer.addEventListener("updateend", slf.loadPacket);
          } else {
            slf.pushPacket(event.data);
          }
        };
      },
      Utf8ArrayToStr(array) {
        var out, i, len, c;
        var char2, char3;
        out = "";
        len = array.length;
        i = 0;
        while (i < len) {
          c = array[i++];
          switch (c >> 4) {
            case 7:
              out += String.fromCharCode(c);
              break;
            case 13:
              char2 = array[i++];
              out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
              break;
            case 14:
              char2 = array[i++];
              char3 = array[i++];
              out += String.fromCharCode(
                ((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0)
              );
              break;
          }
        }
        return out;
      },
    },

    mounted() {
      this.livestream = document.getElementById("videoPlayer" + this.id);
      this.ms = new MediaSource();
      this.ms.addEventListener("sourceopen", this.opened, false);
      this.livestream.src = window.URL.createObjectURL(this.ms);
      if (this.flvPlayer) {
        this.flvPlayer.destroy();
      }
      this.initPlayer();
    },
    destroyed(){
      if(this.videoTypeFlag == 1){
        this.flvPlayer.pause();
        this.flvPlayer.destroy();
        this.flvPlayer = null;
      }
      if(this.videoTypeFlag == 2) {
        this.verbose = true
        this.streamingStarted = false
        this.ms = null;
        this.queue = [];
        this.videoWs.close();
        this.sourceBuffer = null;
        this.decoded_arr = null;
        this.mimeCodec = null;
      }

      try{
        this.videoWs.close();
      }catch (e) {

      }
    }
  };
</script>

<style scoped lang="less">
  .videobox {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;
  }

  .openVideo {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 5px;
    bottom: 5px;
    i {
      color: #afafaf;
      &:hover {
        color: #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/devices/video.vue